import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { DEFAULT_GAS_CHANNEL } from './events';
export function withAnalytics(analytics) {
  return Component => {
    class WrappedComponent extends React.Component {
      constructor(..._args) {
        super(..._args);
        _defineProperty(this, "wrappedAnalyticsCallback", Object.keys(analytics).reduce((acc, key) => ({
          ...acc,
          // We forward all args to the corresponding callback regardless of type
          [key]: (...args) => {
            this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire(DEFAULT_GAS_CHANNEL);
          }
        }), {}));
      }
      render() {
        const {
          createAnalyticsEvent,
          ...rest
        } = this.props;

        // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
        // This is just going to have to go without type safety for the next line.
        return /*#__PURE__*/React.createElement(Component, _extends({}, rest, this.wrappedAnalyticsCallback));
      }
    }
    return withAnalyticsEvents()(WrappedComponent);
  };
}